import React from 'react';
import PropTypes from 'prop-types';
import './Skeleton.scss';

const Skeleton = ({ width, height, maxWidth, borderRadius, margin, boxShadow, bkgColor, animColor='#f0f0f0', aspectRatio, opacity=1 }) => {
    const style = {
        width: width || '100%',
        height: aspectRatio ? undefined : (height || '20px'),
        maxWidth: maxWidth,
        borderRadius: borderRadius || '4px',
        margin: margin || '0',
        boxShadow: boxShadow || '',
        backgroundColor: bkgColor || '#e0e0e0',
        backgroundImage: `linear-gradient(90deg, ${bkgColor} 25%, ${animColor} 50%, ${bkgColor} 75%)`,
        aspectRatio: aspectRatio,
        opacity: opacity,
    };

    return <div className="skeleton" style={style}></div>;
};

Skeleton.propTypes = {
    width: PropTypes.string,
    height: PropTypes.string,
    maxWidth: PropTypes.string,
    borderRadius: PropTypes.string,
    margin: PropTypes.string,
    boxShadow: PropTypes.string,
    bkgColor: PropTypes.string,
    aspectRatio: PropTypes.string,
    opacity: PropTypes.number,
};

export default Skeleton;